import { render, staticRenderFns } from "./wxMenus.vue?vue&type=template&id=5600e267&scoped=true"
import script from "./wxMenus.vue?vue&type=script&lang=js"
export * from "./wxMenus.vue?vue&type=script&lang=js"
import style0 from "./wxMenus.vue?vue&type=style&index=0&id=5600e267&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5600e267",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/cyimu/Desktop/shiliang/vgo/VGO_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5600e267')) {
      api.createRecord('5600e267', component.options)
    } else {
      api.reload('5600e267', component.options)
    }
    module.hot.accept("./wxMenus.vue?vue&type=template&id=5600e267&scoped=true", function () {
      api.rerender('5600e267', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/application/wxAccount/wxMenus.vue"
export default component.exports